export const CROSSSELL_MEDIUM = 'medium';
export const CROSSSELL_SMALL = 'small';
export const CROSSSELL_TINY = 'tiny';
